(function(app) {

    app.provider("investmentAccountTypeApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        service.get = function(investmentAccountTypeId) {
                            return crmApiGateway.get("/InvestmentAccountTypes/" + investmentAccountTypeId);
                        };

                        service.getInvestmentAccountTypes = function() {
                            return crmApiGateway.getArray("/InvestmentAccountTypes");
                        };

                        service.update = function(investmentAccountTypeId, investmentAccountType) {
                            return crmApiGateway.put("/InvestmentAccountTypes/" + investmentAccountTypeId, investmentAccountType);
                        };

                        service.create = function(investmentAccountType) {
                            return crmApiGateway.post("/InvestmentAccountTypes", investmentAccountType);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line